import React from "react";
import {useTranslation} from "react-i18next";
import {UiButton} from "../ui-components/button/uiButton";


export const BackendDown: React.FC = () => {
    const {t} = useTranslation();
    
    return (
        <div className="flex items-center justify-center flex-col h-screen">
            
            <img
                className={"max-h-[50%]"}
                src={"/images/server-down.png"}
                alt=""
            />
            
            <p className={"text-4xl"}>{t("error.server-dont-respond")}</p>
            
            <UiButton
                text={t("global.refresh-page")}
                className={"mt-8"}
                onClick={() => window.location.reload()}
            />
        </div>
    )
}
